import { Fragment, useEffect } from "react";
import useSignIn from "../hooks/useSignIn";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthenticationStatus } from "../../services/authorization/slices";
import { AUTH_STATUS } from "../../util/constants";
import Informational from "../../Common/components/Informational";
import LoadingLogin from "../../Common/components/Loading/Login";
import ExternalLink from "../../Common/components/ExternalLink";

function LogIn() {
  const navigate = useNavigate()
  const authStatus = useSelector((state) => {
    return selectAuthenticationStatus(state);
  });
  const { handleSignIn } = useSignIn();
  const location = useLocation();
  const redirectPath = location?.state?.redirectPath ?? "/";
  useEffect(() => {
    if (authStatus !== AUTH_STATUS.COGNITO_FAILURE) {
      handleSignIn({ redirectPath, doNotRedirect: false });
    }
  }, [redirectPath, handleSignIn, authStatus]);

  useEffect(() => {
    if(AUTH_STATUS.SUCCESS === authStatus) {
      navigate(redirectPath, {
        replace: true
      })
    }
  }, [authStatus, navigate, redirectPath])
  
  if ([AUTH_STATUS.LOADING, AUTH_STATUS.CLEARED, AUTH_STATUS.IDLE].includes(authStatus)) {
    return <LoadingLogin />;
  }

  return (
    <Informational
      info={
        <Fragment>
          There was an error signing you in. If this error continues contact us
          at{" "}
          <ExternalLink href="http://help.osu.edu">help.osu.edu</ExternalLink>.
        </Fragment>
      }
    />
  );
}

export default LogIn;
